/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GDPRConsent } from './GDPRConsent';
import {
    GDPRConsentFromJSON,
    GDPRConsentFromJSONTyped,
    GDPRConsentToJSON,
    GDPRConsentToJSONTyped,
} from './GDPRConsent';

/**
 * 
 * @export
 * @interface GDPRConsentResponse
 */
export interface GDPRConsentResponse {
    /**
     * 
     * @type {Array<GDPRConsent>}
     * @memberof GDPRConsentResponse
     */
    consents: Array<GDPRConsent>;
}

/**
 * Check if a given object implements the GDPRConsentResponse interface.
 */
export function instanceOfGDPRConsentResponse(value: object): value is GDPRConsentResponse {
    if (!('consents' in value) || value['consents'] === undefined) return false;
    return true;
}

export function GDPRConsentResponseFromJSON(json: any): GDPRConsentResponse {
    return GDPRConsentResponseFromJSONTyped(json, false);
}

export function GDPRConsentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'consents': ((json['consents'] as Array<any>).map(GDPRConsentFromJSON)),
    };
}

export function GDPRConsentResponseToJSON(json: any): GDPRConsentResponse {
    return GDPRConsentResponseToJSONTyped(json, false);
}

export function GDPRConsentResponseToJSONTyped(value?: GDPRConsentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consents': ((value['consents'] as Array<any>).map(GDPRConsentToJSON)),
    };
}

